import { AvailableHotelModel } from '@/__generated';
import { HOTEL_CONFIG } from '@/config';
import { getHotelName } from '@/helpers/string';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import HotelStar from './HotelStar';
import { useCurrencyFormat } from '@/hooks/useCurrencyFormat';

type Props = {
  hotel: AvailableHotelModel;
};

const HotelMapItem = ({ hotel }: Props) => {
  const { formatCurrency } = useCurrencyFormat();

  return (
    <div className="col-12" key={hotel?.hotelCode}>
      <div className="shadow-2 bg-white rounded-4 border-base">
        <div className="row x-gap-0">
          <div className="col-4 px-5 py-5">
            <Swiper className="mySwiper">
              {hotel?.hotelImages?.length ? (
                hotel?.hotelImages?.map((slide, i) => (
                  <SwiperSlide key={i}>
                    <img className="w-100 aspect-ratio-1-1 rounded-4" src={slide} alt="hotel" />
                  </SwiperSlide>
                ))
              ) : (
                <SwiperSlide>
                  <img className="w-100 aspect-ratio-1-1 rounded-4" src={HOTEL_CONFIG.defaultImage} alt="hotel" />
                </SwiperSlide>
              )}
            </Swiper>
          </div>
          <div className="col-8 px-10 py-10">
            <h3 className="text-18 lh-16 fw-500">{getHotelName(hotel)}</h3>
            <HotelStar star={hotel.starRating || 0} />
            <div className="row">
              <div className="col-12">
                <p className="text-14">{hotel.address}</p>
              </div>
            </div>
            <div className="row x-gap-6">
              <div className="col-12">
                <div className="text-22 lh-12 fw-600 mt-5">{formatCurrency(hotel.cheapestPrice)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelMapItem;
